import React from 'react'

export const jackets = (props) => {

    return(
        <div>jackets Page</div>
    )


}